import { source } from './Lang';
import { map, ModelRegistry } from './Model';
import { HttpRequest } from './Request';
import { compile, empty, log } from './view/Compiler';


export interface SetupConfig {
	routes?:{ [key:string]:{ url:string, method?:string, headers?:{ [key:string]:string } } },
	data?:{ [key:string]:{} },
	assets?:{ [key:string]:{ url:string, type?:'js'|'css' } },
	lang?:{},
}

var config:SetupConfig;

export function setup( c:SetupConfig, registry?:ModelRegistry ) {
	config = c;

	// setup lang translations
	if( config.lang ) source( config.lang );

	// map data if there is data and a registry
	if( config.data && registry ) {
		config.data = map( config.data, registry );
	}
}

export function data( key:string ):any {
	return lookup( key, config.data );
}

export function asset( key ):Asset {
	return new Asset( lookup( key, config.assets ) );
}


export function route( key:string, urlParams:{} = {} ):HttpRequest {
	let c = lookup( key, config.routes );

	if( !c ) throw new Error( "Route: '" + key + "' could not be found in setup routes." );

	let url =  compile( c.url ).call( { empty:empty, log:log }, urlParams );
	let request = new HttpRequest( url );

	if( c.method ) request.method( c.method );
	if( c.headers ) request.headers( c.headers );

	return request;
}

function lookup( key:string, data:any ) {
	return compile( '[[ ' + key + ' ]]' ).call( { empty:empty, log:log }, data );
}



interface AssetConfig {
	url: string,
	type?: "js" | "css",
}



class Asset {

	// store which assets are already loaded.
	static promises:{ [index:string]: Promise<void> } = {};

	config:AssetConfig;


	constructor( config:AssetConfig ) {
		if( !config.type ) config.type = this.guessType( config.url );
		this.config = config;
	}


	load():Promise<void> {

		// if not loaded create promise
		if( !Asset.promises[ this.config.url ] ) {
			( this.config.type == "js" ) ? this.loadScript() : this.loadCSS();
		}

		return Asset.promises[ this.config.url ];
	}

	/**
	 * Loads a js file into dom
	 */
	private loadScript() {

		var url = this.config.url;

		Asset.promises[ url ] = new Promise<void>( ( resolve, reject ) => {
			var element = document.createElement( 'script' );
			element.src = url;
			element.addEventListener( 'load', event => resolve() );
			element.addEventListener( 'error', event => reject() );
			document.body.appendChild( element );
		}).then( event => {
			this.finalize( url );
		});
	}

	/**
	 * Loads a css file into the dom
	 */
	private loadCSS() {

		var url = this.config.url;

		Asset.promises[ url ] = new Promise<void>( ( resolve, reject ) => {
			var element = document.createElement( 'link' );
			element.type = 'text/css';
			element.rel = 'stylesheet';
			element.href = url;
			element.addEventListener( 'load', event => resolve() );
			element.addEventListener( 'error', event => reject() );
			document.head.appendChild( element );
		}).then( event => {
			this.finalize( url );
		});
	}

	private finalize( url:string ) {
		Asset.promises[ url ] = new Promise<void>( ( resolve, reject ) => resolve() );
	}

	/**
	 * Guesses the type based on the given url
	 */
	private guessType( url:string ):"js"|"css" {
		return ( url.split('.').pop() == "js" ) ? 'js' : 'css';
	}
}

